<template>
  <div class="container pt20 pb80">
    <div class="w1200">
      <div class="top mb20 pad0-28" style="padding: 0 20px;" v-if="!isFileHomework">
        <div class="title mr6 oneEllipsis">{{ info.workName }}</div>
        <div class="serial mr20">
          （<span>{{ current }}</span
          >/{{ total }}题）
        </div>
        <div class="submit-finish" v-if="isSubmit == 1">
          <img src="@/assets/LearningCenter/homework-finishTime.png" class="icon mr6" />
          <span class="title">完成作业用时：</span>
          <span class="time">{{ info.duration }}</span>
        </div>
        <template v-else>
          <div class="but but-save mr24" @click="pageSubmit(1)">退出并保存</div>
          <div class="but but-sub" @click="pageSubmit(2)">提交作业</div>
        </template>
        <template v-if="isSubmit == 1 && info.achievement != undefined">
          <img src="@/assets/LearningCenter/homework-bjg.png" class="grade-icon" v-if="info.achievement == 0" />
          <img src="@/assets/LearningCenter/homework-jg.png" class="grade-icon" v-if="info.achievement == 1" />
          <img src="@/assets/LearningCenter/homework-lh.png" class="grade-icon" v-if="info.achievement == 2" />
          <img src="@/assets/LearningCenter/homework-yx.png" class="grade-icon" v-if="info.achievement == 3" />
        </template>
      </div>

      <div class="question-body pb80">
        <!-- 题目 -->
        <div :class="{ question: true, 'questionHeight pb40': isFileHomework }">
          <div :class="{ 'question-main pb10': true, 'question-full': questionList.length <= 1 && isSubmit != 1 }">
            <Question ref="questionItemRef" :info="questionList[current - 1]" :pageType="2" :imgCount="9" :isSubmit="Boolean(isSubmit == 1)" @watchUserAnswer="watchUserAnswer">
              <template #title v-if="isFileHomework">
                <div class="mb24 fileTitle">
                  <img src="@/assets/questionBank/homework-file-word.png" class="fileTitle-icon mr16" />
                  <div class="fileTitle-content mr20">
                    <div class="title oneEllipsis">
                      {{ info.workName }}
                    </div>
                    <div class="file-down mt12 pointer" @click="downFile">
                      <img src="@/assets/questionBank/file-down.png" class="mr8" />
                      <span>下载</span>
                    </div>
                  </div>
                  <template v-if="isSubmit != 1">
                    <div class="but but-save mr24" @click="pageSubmit(1)">退出并保存</div>
                    <div class="but but-sub mr8" @click="pageSubmit(2)">提交作业</div>
                  </template>
                  <template v-else>
                    <div class="file-hs mr24">
                      <img src="@/assets/LearningCenter/homework-finishTime.png" class="mr6" />
                      <span>完成作业用时：</span>
                      <span style="color: #333">{{ info.duration }}</span>
                    </div>
                    <div class="file-ask-but pointer" @click="showAsk">我要提问</div>
                  </template>
                </div>
              </template>
            </Question>
          </div>
          <!-- 上一题 下一题 -->
          <div :class="{ 'question-bottom-but': true, 'question-bottom-submit': isSubmit == 1 }" v-if="questionList.length > 1 || (questionList.length <= 1 && isSubmit == 1 && !isFileHomework)">
            <template v-if="questionList.length > 1">
              <div :class="{ 'question-bottom-but-item pointer': true, 'question-bottom-but-disable': current <= 1 }" @click="preview">
                <div class="arrow mr18">
                  <img src="@/assets/questionBank/leftArrow.png" />
                  <img src="@/assets/questionBank/left-blue.png" />
                </div>
                <span>上一题</span>
              </div>
              <div :class="{ 'question-bottom-but-item pointer': true, 'question-bottom-but-disable': current == questionList.length }" @click="next">
                <span>下一题</span>
                <div class="arrow ml18">
                  <img src="@/assets/questionBank/rightArrow.png" />
                  <img src="@/assets/questionBank/right-blue.png" />
                </div>
              </div>
            </template>
            <div class="ask-but pointer" @click="showAsk" v-if="isSubmit == 1 && !isFileHomework">我要提问</div>
          </div>
        </div>

        <!-- 我要提问 -->
        <div class="mask" v-if="isShowAsk">
          <div class="ask-box">
            <div class="ask-main">
              <div class="ask-title mb28">我要提问</div>
              <div class="textarea-box">
                <el-input v-model="askInfo.content" placeholder="请输入您的问题~" resize="none" type="textarea" maxlength="200" class="inputi mb20" />
                <div class="wordLength">
                  <span>{{ askInfo.content ? askInfo.content.length : 0 }}</span>
                  <span>/200</span>
                </div>
              </div>
              <div class="ask-img">
                <div class="upload-img">
                  <div class="upload-item mr12" v-for="(item, index) in askInfo.imgList" :key="item.url">
                    <el-image :src="item.url" fit="cover" class="upload-cover" :preview-src-list="getImgList()" :initial-index="index" v-if="item.url" />
                    <img src="@/assets/questionBank/upload-del.png" class="upload-del pointer" @click="delImg(index)" />
                  </div>
                  <img src="@/assets/questionBank/uploadImg.png" class="upload-item pointer" v-if="askInfo.imgList.length < 9" @click="clickUpload" />
                  <input ref="fileInput" type="file" accept="image/png,image/jpg,image/jpeg" multiple @change="fileChange" class="fileInput" />
                </div>
                <div class="ask-img-tips mt12">
                  <span>{{ askInfo.imgList.length }}</span>
                  <span>/9 点击上传答案（最多可上传9张）</span>
                </div>
              </div>
              <div class="ask-record mt20 pb20">
                <div class="ask-record-title pl10 mb16">上传录音</div>
                <div class="ask-record-flex mb16">
                  <el-button
                    :class="{ 'ask-record-but': true, 'ask-record-start': !isRecord, 'ask-record-ing': isRecord }"
                    @click="record"
                    :loading="uploadRecordLoading"
                    :disabled="uploadRecordLoading"
                  >
                    <img src="@/assets/questionBank/record-1.png" v-if="!isRecord" />
                    <img src="@/assets/questionBank/record-2.png" v-else />
                    <span>{{ isRecord ? "正在录音" : "点击录音" }}</span>
                  </el-button>
                  <div class="ask-record-tips ml12">
                    <span>{{ askInfo.recordingList.length }}</span>
                    <span>/9 点击上传录音（最多可上传9条）</span>
                  </div>
                </div>
                <RecordList ref="recordListRef" :list="askInfo.recordingList" :isRecord="isRecord" @del="delRecord" />
              </div>
            </div>
            <div class="ask-but-setUp"></div>
            <div class="ask-but-box">
              <div class="ask-but-item pointer" @click="showAsk">取消</div>
              <el-button class="ask-but-item" @click="askSubmit" :loading="askLoading" :disabled="askLoading">提交</el-button>
            </div>
          </div>
        </div>

        <!-- 答题卡 -->
        <div class="sheet" style="height: 340px" v-if="questionList.length > 1">
          <div class="sheet-top">
            <div class="sheet-left">
              <img src="@/assets/questionBank/iconmenu.png" />
              <span>答题卡</span>
            </div>
            <div class="sheet-right">
              <div class="sheet-right-item sheet-already">
                <div class="sheet-right-item-status"></div>
                <span>已答 {{ alreadyNumber }}</span>
              </div>
              <div class="sheet-right-item sheet-noAnswer">
                <div class="sheet-right-item-status"></div>
                <span>未答 {{ noAnswerNumber }}</span>
              </div>
            </div>
          </div>
          <div class="sheet-main">
            <div class="sheet-main-item-for">
              <div
                :class="{
                  'sheet-main-item-for-i': true,
                  pointer: true,
                  already: item.isAnswer,
                }"
                v-for="(item, index) in questionSheet"
                :key="index"
                @click="changeCurrent(item, index)"
              >
                {{ index + 1 }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
      <!-- 交卷提示 -->
  <div class="mask" v-if="hintShow">
    <div class="sub-tips-box">
      <div class="sub-tips" v-if="noAnswerNumber">
        您还有 <span>{{ noAnswerNumber }}道</span> 题未做，是否
        <div>确认提交？</div>
      </div>
      <div class="sub-tips" v-else>完成作业，是否确认提交？</div>
      <div class="sub-tips-but">
        <div class="sub-tips-but-item sub-tips-but-left pointer" @click="cancelHint">继续做题</div>
        <el-button class="sub-tips-but-item sub-tips-but-right pointer" type="primary" @click="submit" :loading="submitLoading" :disabled="submitLoading">提交</el-button>
      </div>
    </div>
  </div>
  </div>


</template>

<script>
import { Notification } from 'element-ui';
import Recorder from "recorder-core";
import "recorder-core/src/engine/mp3";
import "recorder-core/src/engine/mp3-engine";

import Question from "./components/question.vue";
import RecordList from "./components/recordList.vue";
import { HomeClient } from "@/api/home";
const homeClient = new HomeClient();
import { uploadFile } from "@/utils/uploadTSP"; 
 
export default {
  name: 'myOperationDetails',
  components: {
    Question,
    RecordList
  },
  data() {
    return {
      // 是否提交
      isSubmit: null, // 0未提交 1已提交 2待提交
      current: 0,
      total: 0,
      questionList: [{}],
      info: {},
      // 是否是文件类型的作业
      isFileHomework: false,
      alreadyNumber: 0, // 已答数量
      noAnswerNumber: 0, // 未答数量
      questionSheet: [], // 答题卡
      // 计时
      timer: null,
      second: 0,
      // 交卷提示
      hintShow: false,
      submitLoading: false,
      // 我要提问
      isShowAsk: false,
      askInfo: {
        content: "",
        imgList: [],
        recordingList: [],
        workId: this.$route.query.workId,
        workStudentId: this.$route.query.workStudentId,
      },
      isRecord: false,
      uploadRecordLoading: false,
      askLoading: false,  
      rec: null
    };
  },
  mounted() {
    homeClient
      .getIsSubmit({
        workStudentId: this.$route.query.workStudentId,
      })
      .then((res) => {
        this.isSubmit = res.data;
        if (this.isSubmit == 0) {
          this.getInfo();
        } else {
          this.getStudentInfo();
        }
      
      });
  },
  beforeDestroy() {
    clearInterval(this.timer);
    homeClient.saveWorkProgress(this.disposeData()).then((res) => {
      if (res.code == 0) {
        Notification({
          title: "提示",
          message: "已保存做题记录",
          type: "success",
          duration: 1000,
          zIndex: 2100,
        });
      }
    });
  },
  methods: {
    // 获取作业详情
    getInfo() {
      homeClient
        .getWorkDetails({
          workId: this.$route.query.workId,
          workTeacherId: this.$route.query.workTeacherId,
        })
        .then((res) => {
          this.toDo(res);
        });
    },
    
    // 获取学生作答详情
    getStudentInfo() {
      homeClient
        .getStudentAnswer({
          workStudentId: this.$route.query.workStudentId,
        })
        .then((res) => {
          this.toDo(res);
          if (this.isSubmit == 1) {
            this.getWorkQuestion();
          }
        });
    },
    
    // 获取答疑列表
    getWorkQuestion() {
      
      if (!this.questionList[this.current - 1].workQuestionList || !this.questionList[this.current - 1].workQuestionList.length) {
        homeClient
          .getWorkQuestionList({
            studentAnswerId: this.questionList[this.current - 1].studentAnswerId,
          })
          .then((res) => {
            this.questionList[this.current - 1].workQuestionList = res.data;
          });
      }
    },
    
    toDo(res) {
      this.info = res.data;
      this.isFileHomework = res.data.workWay == 2;
      if (this.isFileHomework) {
        this.total = 1;
        this.current = 1;
        if (this.isSubmit == 0) {
          this.questionList = [
            {
              questionType: 999,
              imgList: [],
              userAnswer: "",
              userAnswerImgList: [],
              userAnswerRecordingList: [],
            },
          ];
        } else {
          this.questionList = this.setQuestion(res.data.workSubjectList);
        }
      } else {
        this.total = res.data.workSubjectList.length;
        if (this.total) this.current = 1;
        this.questionList = this.setQuestion(res.data.workSubjectList);
      }
      this.watchUserAnswer();
      this.startTime();
    },
    
    // 计时
    startTime() {
      if (this.isSubmit == 1) return;
      this.timer && clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.second++;
      }, 1000);
    },
    
    // 设置题目数据
    setQuestion(arr) {
      this.questionSheet = [];
      arr.forEach((item) => {
        item.questionType = this.isFileHomework ? 999 : 3;
        item.questionTitle = item.subjectContent;
        item.imgList = item.userAnswerImgList ? item.userAnswerImgList.map((i, index) => ({ url: i })) : [];
        item.userAnswerRecordingList = item.userAnswerRecordingList ? item.userAnswerRecordingList : [];
        item.questionAnswerAnalysis = item.subjectAnswerAnalysis;
        if (item.teacherComment) {
          item.comment = {
            content: item.teacherComment.comment,
            img: item.teacherComment.teacherCommentImgList,
            recordList: item.teacherComment.teacherCommentRecordingList,
            ...item.teacherComment,
          };
        } else {
          item.comment = {};
        }
        item.workQuestionList = item.workQuestionList ? item.workQuestionList : [];
        this.questionSheet.push(item);
      });
      return arr;
    },
    
    // 下载文件
    downFile() {
      window.open(this.info.workFile);
    },
    
    // 跳转题目
    changeCurrent(item, index) {
      if (this.$refs.questionItemRef.getIsRecord()) {
        Notification.closeAll();
        Notification({
          title: "提示",
          message: `请先结束录音`,
          type: "warning",
          duration: 2000,
          zIndex: 2100,
        });
        return;
      }
      this.current = index + 1;
      if (this.isSubmit == 1) {
        this.getWorkQuestion();
      }
    },
    
    // 上一题
    preview() {
      if (this.$refs.questionItemRef.getIsRecord()) {
        Notification.closeAll();
        Notification({
          title: "提示",
          message: `请先结束录音`,
          type: "warning",
          duration: 2000,
          zIndex: 2100,
        });
        return;
      }
      if (this.current <= 1) return;
      this.current--;
      if (this.isSubmit == 1) {
        this.getWorkQuestion();
      }
    },
    
    // 下一题
    next() {
      if (this.$refs.questionItemRef.getIsRecord()) {
        Notification.closeAll();
        Notification({
          title: "提示",
          message: `请先结束录音`,
          type: "warning",
          duration: 2000,
          zIndex: 2100,
        });
        return;
      }
      if (this.current >= this.questionList.length) return;
      this.current++;
      if (this.isSubmit == 1) {
        this.getWorkQuestion();
      }
    },
    
    // 1退出并保存 2提交作业
    disposeData() {
      const data = JSON.parse(JSON.stringify(this.info));
      data.distributeSecond = this.second;
      if (this.isFileHomework) {
        data.workSubjectList = JSON.parse(JSON.stringify(this.questionList));
        data.workSubjectList[0].userAnswerImgList = data.workSubjectList[0].imgList.map((i) => i.url);
      } else {
        data.workSubjectList.forEach((item) => {
          item.userAnswerImgList = item.imgList.map((i) => i.url);
          item.userAnswerImg = item.userAnswerImgList.join(",");
          item.userAnswerRecording = item.userAnswerRecordingList.join(",");
        });
      }
      return data;
    },
    
    pageSubmit(type) {
      if (this.$refs.questionItemRef.getIsRecord()) {
        Notification.closeAll();
        Notification({
          title: "提示",
          message: `请先结束录音`,
          type: "warning",
          duration: 2000,
          zIndex: 2100,
        });
        return;
      }
      if (type == 1) {
        this.$router.back();
      } else if (type == 2) {
        this.hintShow = true; 
      }
    },
    
    // 继续做题
    cancelHint() {
      if (this.submitLoading) return;
      this.hintShow = false; 
    },
    
    // 提交
    submit() {
      clearInterval(this.timer);
      this.submitLoading = true;
      homeClient.submitWork(this.disposeData()).then((res) => {
        this.submitLoading = false;
        if (res.code == 0) {
          this.cancelHint();
          this.isSubmit = 1;
          this.getStudentInfo();
        }
      });
    },
    
    // 显示/隐藏提问弹窗
    showAsk() {
      if (this.askLoading) return;
      if (this.isRecord) {
        Notification.closeAll();
        Notification({
          title: "提示",
          message: `请先结束录音`,
          type: "warning",
          duration: 2000,
          zIndex: 2100,
        });
        return;
      }
      this.isShowAsk = !this.isShowAsk; 
      this.askInfo.content = "";
      this.askInfo.imgList = [];
      this.askInfo.recordingList = [];
    },
    
    // 我的提问图片上传
    clickUpload() {
      this.$refs.fileInput.value = "";
      this.$refs.fileInput.click();
    },
    
    fileChange(e) {
      const files = Array.from(e.target.files).filter((i) => i.type.includes("image"));
      const arr = files.slice(0, 9 - this.askInfo.imgList.length);
      arr.forEach(async (item) => {
        const url = await uploadFile(item);
        this.askInfo.imgList.push({
          url: url,
        });
      });
    },
    
    delImg(index) {
      this.askInfo.imgList.splice(index, 1);
    },
    
    getImgList() {
      return this.askInfo.imgList.map((i) => i.url);
    },
    
    // 我的提问录音
    record() {
      if (this.askInfo.recordingList.length >= 9) return;
      if (this.$refs.recordListRef.isPlay()) {
        Notification.closeAll();
        Notification({
          title: "提示",
          message: "请先暂停当前播放的录音",
          type: "warning",
          duration: 2000,
          zIndex: 2100,
        });
        return;
      }
      if (!this.isRecord) {
        
        this.rec = Recorder({
          type: "mp3", //录音格式，可以换成wav等其他格式
          sampleRate: 16000, //录音的采样率，越大细节越丰富越细腻
          bitRate: 16, //录音的比特率，越大音质越好
        });
        this.rec.open(
          () => {
            this.rec.start();
            this.isRecord = true;
          },
          () => {
            Notification.closeAll();
            Notification({
              title: "提示",
              message: "请检查您的硬件设备和麦克风权限",
              type: "warning",
              duration: 2000,
              zIndex: 2100,
            });
          }
        );
      } else {
        this.isRecord = false; 
        this.rec.stop(
          (blob) => {
            const file = new window.File([blob], new Date().getTime() + "" + parseInt(Math.random() * 10000 + "") + ".mp3");
            const url = (window.URL || webkitURL).createObjectURL(blob);
            this.getRecordFile({
              file,
              url,
            });
          },
          (err) => {
            console.error("结束录音出错：", err);
          }
        );
      }
    },
    
    async getRecordFile(data) {
      this.uploadRecordLoading = true;
      const url = await uploadFile(data.file, {
        path: "/record",
        bucketName: "1678655958080851969-other",
      });
      this.uploadRecordLoading = false;
      this.askInfo.recordingList.push(url);
    },
    
    delRecord(index) {
      this.askInfo.recordingList.splice(index, 1);
    },
    
    // 我的提问提交
    askSubmit() {
      if (this.isRecord) {
        Notification.closeAll();
        Notification({
          title: "提示",
          message: `请先结束录音`,
          type: "warning",
          duration: 2000,
          zIndex: 2100,
        });
        return;
      }
      if ((!this.askInfo.content || !this.askInfo.content.trim()) && !this.askInfo.imgList.length && !this.askInfo.recordingList.length) {
        Notification.closeAll();
        Notification({
          title: "提示",
          message: `请输入提问内容`,
          type: "warning",
          duration: 2000,
          zIndex: 2100,
        });
        return;
      }

      this.askLoading = true;
      const data = JSON.parse(JSON.stringify(this.askInfo));
      data.imgList = data.imgList.map((i) => i.url);

      const questionInfo = this.questionList[this.current - 1];
      data.studentAnswerId = questionInfo.studentAnswerId;
      data.subjectId = questionInfo.subjectId;

      homeClient
        .addWorkAskQuestion(data)
        .then((res) => {
          this.askLoading = false;
          console.log(res);
          
          if (res.code == 0) {
            this.showAsk();
            this.getWorkQuestion();
          }
        })
        .catch(() => {
          this.askLoading = false;
        });
    },
    
    // 监听用户作答
    watchUserAnswer(arr = this.questionList) {
      let alreadyCount = 0;
      arr.forEach((value) => {
        value.isAnswer = Boolean(value.userAnswer) || Boolean(value.imgList.length) || Boolean(value.userAnswerRecordingList.length);
        if (value.isAnswer) alreadyCount++;
      });
      this.alreadyNumber = alreadyCount;
      this.noAnswerNumber = this.total - this.alreadyNumber;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/style/questionBank/question.scss";

.container {
  // background-color: #f7f8fb;
}
.w1200 {
  width: 1200px;
  margin: 0 auto;
}
.top {
  height: 74px;
  background-color: #fff;
  background-image: url("~@/assets/questionBank/homework-title-bg.png");
  background-size: 100% 100%;
  box-shadow: 0px 0px 6px 1px rgba(204, 204, 204, 0.3);
  border-radius: 6px;
  display: flex;
  align-items: center;
  position: relative;
  .title {
    font-size: 20px;
    color: #333;
    font-weight: bold;
    max-width: 760px;
  }
  .grade-icon {
    width: 62px;
    height: 62px;
    position: absolute;
    right: 277px;
    top: 50%;
    transform: translateY(-50%);
  }
}
.serial {
  flex: 1;
  font-size: 14px;
  color: #aaa;
  span {
    color: #3366ff;
  }
}
.submit-finish {
  display: flex;
  align-items: center;
  font-size: 14px;
  .icon {
    width: 13px;
    height: 14px;
    transform: translateY(1px);
  }
  .title {
    font-size: 14px;
    color: #aaa;
    font-weight: normal;
  }
  .time {
    font-size: #333;
  }
}
.but {
  width: 130px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  border-radius: 4px;
  cursor: pointer;
}
.but-save {
  border: 1px solid #3366ff;
  color: #3366ff;
}
.but-sub {
  background-color: #3366ff;
  color: #fff;
}
.file-hs {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #aaa;
  img {
    width: 13px;
    height: 14px;
  }
}
.file-ask-but {
  width: 144px;
  height: 40px;
  border-radius: 4px;
  background: linear-gradient(180deg, #97b2ff 0%, #3067ff 100%);
  color: #fff;
  font-size: 16px;
  text-align: center;
  line-height: 40px;
}
.sheet-main {
  height: 270px;
  border-bottom: none !important;
}
.question {
  flex: 1;
  width: auto;
}
.questionHeight {
  height: auto;
}
.question-main {
  height: calc(100% - 66px);
}
.question-full {
  height: 100%;
}
.fileTitle {
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  &::before {
    content: "";
    width: 1200px;
    height: 74px;
    background-image: url("~@/assets/questionBank/homework-title-bg.png");
    background-size: 100% 100%;
    position: absolute;
    left: -24px;
    top: -26px;
    z-index: -1;
  }
  .fileTitle-icon {
    width: 60px;
    height: 60px;
  }
  .fileTitle-content {
    flex: 1;
    width: 0;
    .title {
      font-size: 18px;
      color: #333;
      font-weight: bold;
    }
    .file-down {
      display: inline-block;
      font-size: 18px;
      color: #3366ff;
      img {
        width: 16px;
        height: 16px;
      }
    }
  }
}
.question-bottom-submit {
  justify-content: flex-start;
  position: relative;
}
.ask-but {
  width: 144px;
  height: 40px;
  border-radius: 4px;
  background: linear-gradient(180deg, #97b2ff 0%, #3067ff 100%);
  color: #fff;
  font-size: 14px;
  text-align: center;
  line-height: 40px;
  position: absolute;
  right: 36px;
  top: 50%;
  transform: translateY(-50%);
}
.ask-box {
  width: 876px;
  border-radius: 8px;
  background-color: #fff;
  position: relative;
  .ask-main {
    padding: 28px 32px 0;
    height: calc(100% - 104px);
    overflow-y: auto;
  }
  .ask-title {
    font-size: 18px;
    color: #333;
    text-align: center;
    font-weight: bold;
  }
  .textarea-box {
    position: relative;
    .inputi {
      height: 180px;
      ::v-deep textarea {
        height: 100%;
        padding: 14px 16px;
        font-size: 15px;
        color: #333 !important;
        box-shadow: none !important;
        background-color: #f7f7fa !important;
        word-break: break-all;
      }
      ::v-deep .el-input__count {
        bottom: 14px;
        right: 16px;
      }
    }
    .wordLength {
      font-size: 14px;
      color: #777;
      position: absolute;
      right: 16px;
      bottom: 32px;
      span:first-child {
        color: #3366ff;
      }
    }
  }
  .ask-img {
    .upload-img {
      display: flex;
      flex-wrap: wrap;
    }
    .upload-item {
      width: 78px;
      height: 78px;
      position: relative;
      .upload-cover {
        width: 100%;
        height: 100%;
        border-radius: 8px;
      }
      .upload-del {
        width: 16px;
        height: 16px;
        position: absolute;
        top: -8px;
        right: -8px;
      }
    }
    .fileInput {
      opacity: 0;
      display: none;
    }
    .ask-img-tips {
      font-size: 14px;
      color: #aaa;
      span:first-child {
        color: #3366ff;
      }
    }
  }
  .ask-record {
    .ask-record-title {
      font-size: 16px;
      color: #333;
      position: relative;
      &::before {
        content: "";
        width: 4px;
        height: 12px;
        background-color: #3366ff;
        border-radius: 2px;
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
      }
    }
    .ask-record-flex {
      display: flex;
      align-items: flex-end;
    }
    .ask-record-but {
      width: 144px;
      height: 40px;
      border-radius: 4px;
      color: #fff;
      font-size: 14px;
      display: flex;
      align-items: center;
      justify-content: center;
      border: none;
      img {
        width: 13px;
        height: 18px;
        margin-right: 6px;
      }
    }
    .ask-record-start {
      background: linear-gradient(180deg, #97b2ff 0%, #3067ff 100%);
    }
    .ask-record-ing {
      background: linear-gradient(180deg, #ffa997 0%, #ff3030 100%);
    }
    .ask-record-tips {
      font-size: 14px;
      color: #aaa;
      span:first-child {
        color: #3366ff;
      }
    }
  }
  .ask-but-setUp {
    height: 104px;
  }
  .ask-but-box {
    width: 100%;
    height: 104px;
    box-shadow: 0px -3px 6px 1px rgba(204, 204, 204, 0.16);
    background-color: #fff;
    border-radius: 0 0 8px 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    left: 0;
    bottom: 0;
    .ask-but-item {
      width: 208px;
      height: 44px;
      border-radius: 22px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 16px;
      margin: 0 20px;
      &:nth-child(1) {
        border: 1px solid #eee;
        color: #777;
      }
      &:nth-child(2) {
        background-color: #3366ff;
        color: #fff;
      }
    }
  }
}
.question-bottom-but {
  background-color: #fff;
}
</style>